<template>
  <section
    v-bind:style="image"
    class="w-full h-screen px-3 antialiased bg-green-500 lg:px-6"
  >
    <div class="mx-auto h-full">
      <nav
        class="flex items-center w-full h-24 select-none"
        x-data="{ showMenu: false }"
      >
        <div
          class="
            static
            flex flex-wrap
            items-center
            justify-between
            w-full
            h-full
            mx-auto
            font-medium
            md:justify-center
          "
        >
          <div class="flex items-center justify-items-start w-2/5 md:w-1/5">
            <div
              class="w-10 md:w-20 h-8 md:h-20 m-0 md:m-5"
              v-bind:style="logoImage"
            ></div>
          </div>

          <!-- menu -->
          <div
            class="
              fixed
              top-0
              left-0
              items-center
              hidden
              w-full
              h-24
              p-3
              text-xl
              bg-gray-900 bg-opacity-50
              md:text-sm
              lg:text-base
              md:w-3/4 md:bg-transparent md:p-0 md:relative md:flex
            "
            :class="{ flex: showMenu, hidden: !showMenu }"
          >
            <div
              class="
                flex-col
                w-full
                h-auto h-full
                overflow-hidden
                bg-white
                rounded-lg
                select-none
                md:bg-transparent
                md:rounded-none
                md:relative
                md:flex
                md:flex-row
                md:overflow-auto
              "
            >
              <div
                class="
                  flex flex-col
                  items-center
                  justify-center
                  w-full
                  h-full
                  mt-12
                  text-center text-indigo-700
                  md:text-indigo-200
                  md:w-2/3
                  md:mt-0
                  md:flex-row
                  md:items-center
                "
              >
                <a
                  href="#about-us"
                  class="
                    inline-block
                    px-0 px-4
                    py-2
                    mx-2
                    font-medium
                    text-left
                    md:px-0
                    hover:text-green
                    md:hover:text-white
                    lg:mx-3
                    md:text-center
                  "
                  >PENGENALAN</a
                >
                <a
                  href="#product"
                  class="
                    inline-block
                    px-0 px-4
                    py-2
                    mx-2
                    font-medium
                    text-left
                    md:px-0
                    hover:text-white
                    md:hover:text-white
                    lg:mx-3
                    md:text-center
                  "
                  >PRODUK</a
                >
                <a
                  href="#activity"
                  class="
                    inline-block
                    px-0 px-4
                    py-2
                    mx-2
                    font-medium
                    text-left
                    md:px-0
                    hover:text-white
                    md:hover:text-white
                    lg:mx-3
                    md:text-center
                  "
                  >AKTIVITI</a
                >
                <a
                  href="#awards"
                  class="
                    inline-block
                    px-0 px-4
                    py-2
                    mx-2
                    font-medium
                    text-left
                    md:px-0
                    hover:text-white
                    md:hover:text-white
                    lg:mx-3
                    md:text-center
                  "
                  >PENGANUGERAHAN</a
                >
                <router-link
                  to="/contact"
                  href="#"
                  class="
                    inline-block
                    px-0 px-4
                    py-2
                    mx-2
                    font-medium
                    text-left
                    md:px-0
                    hover:text-white
                    md:hover:text-white
                    lg:mx-3
                    md:text-center
                  "
                  >HUBUNGI KAMI</router-link
                >
              </div>
              <div
                class="
                  animate-pulse
                  flex
                  items-center
                  justify-center
                  w-full
                  h-full
                  pt-4
                  md:w-1/3 md:flex-row md:py-0
                "
              >
                <div class="flex -space-x-2 overflow-hidden">
                  <img
                    v-if="user.image_url"
                    @click="showSlideOverOrRedirect"
                    class="
                      inline-block
                      m-3
                      h-12
                      w-12
                      rounded-full
                      ring-2 ring-green-500
                    "
                    :src="user.image_url"
                    alt="avatar-default"
                  />
                  <img
                    v-else
                    @click="showSlideOverOrRedirect"
                    class="
                      inline-block
                      m-3
                      h-12
                      w-12
                      rounded-full
                      ring-2 ring-green-500
                    "
                    src="@/assets/images/user.png"
                    alt="avatar-default"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Mobile Menu -->
          <div
            @click="showMobileMenu = !showMobileMenu"
            class="
              absolute
              right-0
              z-50
              flex flex-col
              items-end
              w-10
              h-10
              p-2
              mr-4
              rounded-full
              cursor-pointer
              md:hidden
              hover:bg-gray-900 hover:bg-opacity-10
            "
            :class="{ 'text-gray-400': showMenu, 'text-gray-100': !showMenu }"
          >
            <svg
              class="w-6 h-6"
              x-show="!showMenu"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
              x-cloak=""
            >
              <path d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </div>
          <!--
    Mobile menu, show/hide based on mobile menu state.

    Entering: "duration-200 ease-out"
      From: "opacity-0 scale-95"
      To: "opacity-100 scale-100"
    Leaving: "duration-100 ease-in"
      From: "opacity-100 scale-100"
      To: "opacity-0 scale-95"
  -->
          <div
            v-if="showMobileMenu"
            class="
              absolute
              top-0
              inset-x-0
              p-2
              transition
              transform
              origin-top-right
              md:hidden
              z-40
            "
          >
            <div
              class="
                rounded-lg
                shadow-lg
                ring-1 ring-black ring-opacity-5
                bg-white
                divide-y-2 divide-gray-50
              "
            >
              <div class="pt-5 pb-6 px-5">
                <div class="flex items-center justify-between">
                  <div>
                    <img
                      class="h-8 w-auto"
                      src="@/assets/images/logo-primary.png"
                      alt="Workflow"
                    />
                  </div>
                  <div class="-mr-2">
                    <button
                      @click="showMobileMenu = !showMobileMenu"
                      type="button"
                      class="
                        bg-white
                        rounded-md
                        p-2
                        inline-flex
                        items-center
                        justify-center
                        text-gray-400
                        hover:text-gray-500 hover:bg-gray-100
                        focus:outline-none
                        focus:ring-2
                        focus:ring-inset
                        focus:ring-indigo-500
                      "
                    >
                      <span class="sr-only">Close menu</span>
                      <svg
                        class="h-6 w-6"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <div class="mt-6">
                  <nav class="grid gap-y-8">
                    <a
                      href="#about-us"
                      class="
                        -m-3
                        p-3
                        flex
                        items-center
                        rounded-md
                        hover:bg-gray-50
                      "
                    >
                      <svg
                        class="flex-shrink-0 h-6 w-6 text-green-500"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                        />
                      </svg>
                      <span class="ml-3 text-base font-medium text-gray-900">
                        Pengenalan
                      </span>
                    </a>

                    <a
                      href="#product"
                      class="
                        -m-3
                        p-3
                        flex
                        items-center
                        rounded-md
                        hover:bg-gray-50
                      "
                    >
                      <svg
                        class="flex-shrink-0 h-6 w-6 text-green-500"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122"
                        />
                      </svg>
                      <span class="ml-3 text-base font-medium text-gray-900">
                        Produk
                      </span>
                    </a>

                    <div
                      href="#activity"
                      class="
                        -m-3
                        p-3
                        flex
                        items-center
                        rounded-md
                        hover:bg-gray-50
                      "
                    >
                      <svg
                        class="flex-shrink-0 h-6 w-6 text-green-500"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                        />
                      </svg>
                      <span
                        @click="showFormOption = !showFormOption"
                        class="ml-3 text-base font-medium text-gray-900"
                      >
                        Aktiviti
                      </span>
                    </div>

                    <a
                      href="#awards"
                      class="
                        -m-3
                        p-3
                        flex
                        items-center
                        rounded-md
                        hover:bg-gray-50
                      "
                    >
                      <svg
                        class="flex-shrink-0 h-6 w-6 text-green-500"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                        />
                      </svg>
                      <span class="ml-3 text-base font-medium text-gray-900">
                        Penganugerahan
                      </span>
                    </a>

                    <div
                      href=""
                      class="
                        -m-3
                        p-3
                        flex
                        items-center
                        rounded-md
                        hover:bg-gray-50
                      "
                    >
                      <svg
                        class="flex-shrink-0 h-6 w-6 text-green-500"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                        />
                      </svg>
                      <span class="ml-3 text-base font-medium text-gray-900">
                        <router-link
                          to="/contact"
                          href="#"
                          class="text-base font-medium hover:text-gray-900"
                        >
                          Hubungi Kami
                        </router-link>
                      </span>
                    </div>
                    <div>
                      <button
                        @click="mobileSignIn"
                        class="
                          w-full
                          flex
                          items-center
                          justify-center
                          px-4
                          py-2
                          border border-transparent
                          rounded-md
                          shadow-sm
                          text-base
                          font-medium
                          text-white
                          bg-green-500
                          hover:bg-indigo-700
                        "
                      >
                        Log Masuk
                      </button>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <!-- Authentication Slide Over -->
      <div
        v-if="showSlideOver"
        class="z-30 absolute inset-0 overflow-hidden"
        aria-labelledby="slide-over-title"
        role="dialog"
        aria-modal="true"
      >
        <div class="absolute inset-0 overflow-hidden">
          <div
            class="
              absolute
              inset-0
              bg-gray-500 bg-opacity-75
              transition-opacity
            "
            aria-hidden="true"
          ></div>
          <div class="fixed inset-y-0 right-0 pl-10 max-w-full flex">
            <div class="relative w-screen max-w-md">
              <!-- Close Button -->
              <div
                class="
                  absolute
                  top-0
                  left-0
                  -ml-8
                  pt-4
                  pr-2
                  flex
                  sm:-ml-10 sm:pr-4
                "
              >
                <button
                  type="button"
                  @click="closeSlideOver"
                  class="
                    rounded-md
                    text-gray-300
                    hover:text-white
                    focus:outline-none focus:ring-2 focus:ring-white
                  "
                >
                  <span class="sr-only">Close panel</span>
                  <!-- Heroicon name: outline/x -->
                  <svg
                    class="h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              <div
                class="
                  h-full
                  flex flex-col
                  py-6
                  bg-white
                  shadow-xl
                  overflow-y-scroll
                "
              >
                <div class="mt-6 relative flex-1 px-4 sm:px-6">
                  <!-- Slide-over content -->
                  <div class="absolute inset-0 px-4 sm:px-6">
                    <div class="h-full flex" aria-hidden="true">
                      <!-- Sign In Content -->
                      <!-- TODO: Set condition for sign in as 1st time user or not -->
                      <div class="m-auto">
                        <div
                          v-if="isLoggedIn && isFirstTimeUser && !isLoad"
                          class="flex-col"
                        >
                          <div class="items-center text-3xl font-semibold">
                            Maklumat Peribadi
                          </div>
                          <div class="my-6">
                            <form class="space-y-6">
                              <!-- Full Name -->
                              <div>
                                <label
                                  for="full-name"
                                  class="
                                    block
                                    text-sm
                                    font-medium
                                    text-gray-700
                                  "
                                >
                                  Nama Penuh
                                </label>
                                <div class="mt-1">
                                  <input
                                    v-model="registrationInformation.fullName"
                                    id="fullName"
                                    name="fullName"
                                    type="fullName"
                                    autocomplete="fullName"
                                    required
                                    class="
                                      appearance-none
                                      block
                                      w-full
                                      px-3
                                      py-2
                                      border border-gray-300
                                      rounded-md
                                      shadow-sm
                                      placeholder-gray-400
                                      focus:outline-none
                                      focus:ring-green-500
                                      focus:border-green-500
                                      sm:text-sm
                                    "
                                  />
                                  <div
                                    v-if="
                                      v$.registrationInformation.fullName.$error
                                    "
                                    class="text-sm font-medium text-red-500"
                                  >
                                    Sila isi ruangan ini
                                  </div>
                                </div>
                              </div>
                              <!-- NRIC -->
                              <div>
                                <label
                                  for="nric"
                                  class="
                                    block
                                    text-sm
                                    font-medium
                                    text-gray-700
                                  "
                                >
                                  No. Kad Pengenalan
                                </label>
                                <div class="mt-1">
                                  <input
                                    v-model="registrationInformation.icNo"
                                    id="nric"
                                    name="nric"
                                    type="nric"
                                    autocomplete="nric"
                                    required
                                    class="
                                      appearance-none
                                      block
                                      w-full
                                      px-3
                                      py-2
                                      border border-gray-300
                                      rounded-md
                                      shadow-sm
                                      placeholder-gray-400
                                      focus:outline-none
                                      focus:ring-green-500
                                      focus:border-green-500
                                      sm:text-sm
                                    "
                                  />
                                  <div
                                    v-if="
                                      v$.registrationInformation.icNo.$error
                                    "
                                    class="text-sm font-medium text-red-500"
                                  >
                                    Sila isi ruangan ini
                                  </div>
                                </div>
                              </div>
                              <!-- Address -->
                              <div>
                                <label
                                  for="address"
                                  class="
                                    block
                                    text-sm
                                    font-medium
                                    text-gray-700
                                  "
                                >
                                  Alamat
                                </label>
                                <div class="mt-1">
                                  <input
                                    v-model="registrationInformation.address"
                                    id="address"
                                    name="address"
                                    type="address"
                                    autocomplete="address"
                                    required
                                    class="
                                      appearance-none
                                      block
                                      w-full
                                      px-3
                                      py-2
                                      border border-gray-300
                                      rounded-md
                                      shadow-sm
                                      placeholder-gray-400
                                      focus:outline-none
                                      focus:ring-green-500
                                      focus:border-green-500
                                      sm:text-sm
                                    "
                                  />
                                  <div
                                    v-if="
                                      v$.registrationInformation.address.$error
                                    "
                                    class="text-sm font-medium text-red-500"
                                  >
                                    Sila isi ruangan ini
                                  </div>
                                </div>
                              </div>
                              <!-- Gender -->
                              <div>
                                <label
                                  for="gender"
                                  class="
                                    block
                                    text-sm
                                    font-medium
                                    text-gray-700
                                  "
                                >
                                  Jantina
                                </label>
                                <div class="mt-1">
                                  <input
                                    v-model="registrationInformation.gender"
                                    id="gender"
                                    name="gender"
                                    type="gender"
                                    autocomplete="gender"
                                    required
                                    class="
                                      appearance-none
                                      block
                                      w-full
                                      px-3
                                      py-2
                                      border border-gray-300
                                      rounded-md
                                      shadow-sm
                                      placeholder-gray-400
                                      focus:outline-none
                                      focus:ring-green-500
                                      focus:border-green-500
                                      sm:text-sm
                                    "
                                  />
                                  <div
                                    v-if="
                                      v$.registrationInformation.gender.$error
                                    "
                                    class="text-sm font-medium text-red-500"
                                  >
                                    Sila isi ruangan ini
                                  </div>
                                </div>
                              </div>
                              <!-- Phone No. -->
                              <div>
                                <label
                                  for="phone-no"
                                  class="
                                    block
                                    text-sm
                                    font-medium
                                    text-gray-700
                                  "
                                >
                                  No. Telefon
                                </label>
                                <div class="mt-1">
                                  <input
                                    v-model="
                                      registrationInformation.phoneNumber
                                    "
                                    id="phone-no"
                                    name="phone-no"
                                    type="phone-no"
                                    autocomplete="phone-no"
                                    required
                                    class="
                                      appearance-none
                                      block
                                      w-full
                                      px-3
                                      py-2
                                      border border-gray-300
                                      rounded-md
                                      shadow-sm
                                      placeholder-gray-400
                                      focus:outline-none
                                      focus:ring-green-500
                                      focus:border-green-500
                                      sm:text-sm
                                    "
                                  />
                                  <div
                                    v-if="
                                      v$.registrationInformation.phoneNumber
                                        .$error
                                    "
                                    class="text-sm font-medium text-red-500"
                                  >
                                    Sila isi ruangan ini
                                  </div>
                                </div>
                              </div>
                              <!-- Email -->
                              <div>
                                <label
                                  for="email"
                                  class="
                                    block
                                    text-sm
                                    font-medium
                                    text-gray-700
                                  "
                                >
                                  Email
                                </label>
                                <div class="mt-1">
                                  <input
                                    v-model="registrationInformation.email"
                                    id="email"
                                    name="email"
                                    type="email"
                                    autocomplete="email"
                                    readonly
                                    disabled
                                    class="
                                      appearance-none
                                      block
                                      w-full
                                      px-3
                                      py-2
                                      border border-gray-300
                                      rounded-md
                                      shadow-sm
                                      bg-gray-100
                                      text-gray-500
                                      sm:text-sm
                                    "
                                  />
                                  <div
                                    v-if="
                                      v$.registrationInformation.email.$error
                                    "
                                    class="text-sm font-medium text-red-500"
                                  >
                                    Sila isi ruangan ini
                                  </div>
                                </div>
                              </div>

                              <!-- Password -->
                              <div>
                                <label
                                  for="password"
                                  class="
                                    block
                                    text-sm
                                    font-medium
                                    text-gray-700
                                  "
                                >
                                  Kata Laluan Baharu
                                </label>
                                <div class="mt-1 relative">
                                  <input
                                    v-model="registrationInformation.password"
                                    id="password"
                                    name="password"
                                    :type="showPassword ? 'text' : 'password'"
                                    autocomplete="new-password"
                                    required
                                    class="
                                      appearance-none
                                      block
                                      w-full
                                      px-3
                                      py-2
                                      pr-10
                                      border border-gray-300
                                      rounded-md
                                      shadow-sm
                                      placeholder-gray-400
                                      focus:outline-none
                                      focus:ring-green-500
                                      focus:border-green-500
                                      sm:text-sm
                                    "
                                  />
                                  <button
                                    type="button"
                                    @click="togglePasswordVisibility"
                                    class="absolute inset-y-0 right-0 pr-3 flex items-center"
                                  >
                                    <svg v-if="!showPassword" class="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                    </svg>
                                    <svg v-else class="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                                    </svg>
                                  </button>
                                  <div
                                    v-if="
                                      v$.registrationInformation.password.$error
                                    "
                                    class="text-sm font-medium text-red-500 mt-1"
                                  >
                                    Sila isi ruangan ini
                                  </div>
                                </div>
                              </div>
                              <div>
                                <label
                                  for="confirmPassword"
                                  class="
                                    block
                                    text-sm
                                    font-medium
                                    text-gray-700
                                  "
                                >
                                  Sahkan Kata Laluan Baharu
                                </label>
                                <div class="mt-1 relative">
                                  <input
                                    v-model="
                                      registrationInformation.confirmPassword
                                    "
                                    @input="debouncedPasswordMatchCheck"
                                    id="confirmPassword"
                                    name="confirmPassword"
                                    :type="showConfirmPassword ? 'text' : 'password'"
                                    autocomplete="new-password"
                                    required
                                    class="
                                      appearance-none
                                      block
                                      w-full
                                      px-3
                                      py-2
                                      pr-10
                                      border border-gray-300
                                      rounded-md
                                      shadow-sm
                                      placeholder-gray-400
                                      focus:outline-none
                                      focus:ring-green-500
                                      focus:border-green-500
                                      sm:text-sm
                                    "
                                  />
                                  <button
                                    type="button"
                                    @click="toggleConfirmPasswordVisibility"
                                    class="absolute inset-y-0 right-0 pr-3 flex items-center"
                                  >
                                    <svg v-if="!showConfirmPassword" class="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                    </svg>
                                    <svg v-else class="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                                    </svg>
                                  </button>
                                  <div v-if="passwordMatchError" class="text-sm font-medium text-red-500 mt-1">
                                    Kata laluan tidak sepadan
                                  </div>
                                  <div
                                    v-if="
                                      v$.registrationInformation.confirmPassword
                                        .$error
                                    "
                                    class="text-sm font-medium text-red-500 mt-1"
                                  >
                                    Sila isi ruangan ini
                                  </div>
                                </div>
                              </div>
                              <div class="items-center text-3xl font-semibold">
                                Maklumat Akaun Bank
                              </div>
                              <!-- Account Holder -->
                              <div>
                                <label
                                  for="acc-holder"
                                  class="
                                    block
                                    text-sm
                                    font-medium
                                    text-gray-700
                                  "
                                >
                                  Nama Pemegang Akaun
                                </label>
                                <div class="mt-1">
                                  <input
                                    v-model="bankInformation.accountHolderName"
                                    id="acc-holder"
                                    name="acc-holder"
                                    type="acc-holder"
                                    autocomplete="acc-holder"
                                    required
                                    class="
                                      appearance-none
                                      block
                                      w-full
                                      px-3
                                      py-2
                                      border border-gray-300
                                      rounded-md
                                      shadow-sm
                                      placeholder-gray-400
                                      focus:outline-none
                                      focus:ring-green-500
                                      focus:border-green-500
                                      sm:text-sm
                                    "
                                  />
                                  <div
                                    v-if="
                                      v$.bankInformation.accountHolderName
                                        .$error
                                    "
                                    class="text-sm font-medium text-red-500"
                                  >
                                    Sila isi ruangan ini
                                  </div>
                                </div>
                              </div>
                              <!-- Account No. -->
                              <div>
                                <label
                                  for="acc-no"
                                  class="
                                    block
                                    text-sm
                                    font-medium
                                    text-gray-700
                                  "
                                >
                                  No. Akaun
                                </label>
                                <div class="mt-1">
                                  <input
                                    v-model="bankInformation.accountNo"
                                    id="acc-no"
                                    name="acc-no"
                                    type="acc-no"
                                    autocomplete="acc-no"
                                    required
                                    class="
                                      appearance-none
                                      block
                                      w-full
                                      px-3
                                      py-2
                                      border border-gray-300
                                      rounded-md
                                      shadow-sm
                                      placeholder-gray-400
                                      focus:outline-none
                                      focus:ring-green-500
                                      focus:border-green-500
                                      sm:text-sm
                                    "
                                  />
                                  <div
                                    v-if="v$.bankInformation.accountNo.$error"
                                    class="text-sm font-medium text-red-500"
                                  >
                                    Sila isi ruangan ini
                                  </div>
                                </div>
                              </div>
                              <!-- Bank Name -->
                              <div>
                                <label
                                  for="bank-issuer"
                                  class="
                                    block
                                    text-sm
                                    font-medium
                                    text-gray-700
                                  "
                                >
                                  Nama Bank
                                </label>
                                <div class="mt-1">
                                  <input
                                    v-model="bankInformation.bankName"
                                    id="bank-issuer"
                                    name="bank-issuer"
                                    type="bank-issuer"
                                    autocomplete="bank-issuer"
                                    required
                                    class="
                                      appearance-none
                                      block
                                      w-full
                                      px-3
                                      py-2
                                      border border-gray-300
                                      rounded-md
                                      shadow-sm
                                      placeholder-gray-400
                                      focus:outline-none
                                      focus:ring-green-500
                                      focus:border-green-500
                                      sm:text-sm
                                    "
                                  />
                                  <div
                                    v-if="v$.bankInformation.bankName.$error"
                                    class="text-sm font-medium text-red-500"
                                  >
                                    Sila isi ruangan ini
                                  </div>
                                </div>
                              </div>
                              <!-- Register Button -->
                              <div class="mb-10">
                                <!-- Todo: @click here to redirect -->
                                <button
                                  type="button"
                                  @click="signUp"
                                  class="
                                    w-full
                                    flex
                                    justify-center
                                    py-2
                                    px-4
                                    border border-transparent
                                    rounded-full
                                    shadow-sm
                                    text-sm
                                    font-medium
                                    text-black
                                    bg-green-fluorescent
                                    hover:opacity-80
                                    focus:outline-none
                                    focus:ring-2
                                    focus:ring-offset-2
                                    focus:ring-green-500
                                  "
                                >
                                  Daftar
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                        <div v-if="!isLoggedIn" class="text-left">
                          <div class="text-5xl font-semibold">Selamat</div>
                          <div class="text-5xl font-semibold">Datang</div>
                          <div class="text-lg pt-2">
                            Sila masukkan Emel dan Kata Laluan
                          </div>
                          <div class="text-lg -mt-2">untuk log masuk</div>
                          <!-- Error Message Display -->
                          <div v-if="errorMessage" class="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-md">
                            {{ errorMessage }}
                          </div>
                          <div class="mt-6">
                            <form class="space-y-6">
                              <!-- Email Address -->
                              <div>
                                <label
                                  for="email"
                                  class="
                                    block
                                    text-sm
                                    font-medium
                                    text-gray-700
                                  "
                                >
                                  Emel
                                </label>
                                <div class="mt-1">
                                  <input
                                    v-model="loginInformation.email"
                                    id="email"
                                    name="email"
                                    type="email"
                                    autocomplete="email"
                                    required
                                    class="
                                      appearance-none
                                      block
                                      w-full
                                      px-3
                                      py-2
                                      border border-gray-300
                                      rounded-md
                                      shadow-sm
                                      placeholder-gray-400
                                      focus:outline-none
                                      focus:ring-green-500
                                      focus:border-green-500
                                      sm:text-sm
                                    "
                                  />
                                </div>
                              </div>
                              <!-- Password -->
                              <div class="space-y-1">
                                <label
                                  for="password"
                                  class="
                                    block
                                    text-sm
                                    font-medium
                                    text-gray-700
                                  "
                                >
                                  Kata Laluan
                                </label>
                                <div class="mt-1">
                                  <input
                                    v-model="loginInformation.password"
                                    id="password"
                                    name="password"
                                    type="password"
                                    autocomplete="current-password"
                                    required
                                    class="
                                      appearance-none
                                      block
                                      w-full
                                      px-3
                                      py-2
                                      border border-gray-300
                                      rounded-md
                                      shadow-sm
                                      placeholder-white
                                      focus:outline-none
                                      focus:ring-green-500
                                      focus:border-green-500
                                      sm:text-sm
                                    "
                                  />
                                </div>
                              </div>
                              <!-- Submit Button -->
                              <div class="pb-10">
                                <!-- Todo: @click here to redirect -->
                                <button
                                  type="button"
                                  @click="signIn"
                                  class="
                                    w-full
                                    flex
                                    justify-center
                                    py-2
                                    px-4
                                    border border-transparent
                                    rounded-full
                                    shadow-sm
                                    text-sm
                                    font-medium
                                    text-black
                                    bg-green-fluorescent
                                    hover:opacity-80
                                    focus:outline-none
                                    focus:ring-2
                                    focus:ring-offset-2
                                    focus:ring-green-500
                                  "
                                >
                                  Log Masuk
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- /End replace -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Landing -->
      <div class="container py-32 my-auto mx-auto text-left sm:px-4">
        <h1
          class="
            text-xl
            md:text-2xl
            font-extrabold
            tracking-tight
            text-white
            sm:text-2xl sm:leading-none
            md:text-4xl
            xl:text-2xl
          "
        >
          <span class="block">SELAMAT DATANG KE LAMAN RASMI</span>
        </h1>
        <h1
          class="
            text-5xl
            md:text-2xl
            font-extrabold
            tracking-tight
            text-white
            sm:text-2xl sm:leading-none
            md:text-4xl
            xl:text-7xl
          "
        >
          <span class="block">KOPERASI</span>
        </h1>
        <h1
          class="
            text-5xl
            md:text-2xl
            font-extrabold
            tracking-tight
            text-white
            sm:text-2xl sm:leading-none
            md:text-4xl
            xl:text-7xl
          "
        >
          <span class="block"> PERTANIAN</span>
        </h1>
        <h1
          class="
            text-5xl
            md:text-2xl
            font-extrabold
            tracking-tight
            text-white
            sm:text-4xl sm:leading-none
            md:text-3xl
            xl:text-7xl
          "
        >
          <span class="block">SABAH BERHAD</span>
        </h1>
      </div>
    </div>
  </section>

  <!-- Arrow Bottom -->
  <div class="relative">
    <a href="#about-us">
      <svg
        class="h-10 mx-auto -mt-10"
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 316.1 143.58"
      >
        <path
          fill="#94de2a"
          fill-opacity="1"
          id="Path_5"
          data-name="Path 5"
          class="cls-1"
          d="M0,143.49s27.81, 0,82.78-84.11,129-67.41,164.66, 0,68.66,84.11,68.66,84.11Z"
        />
        <path
          fill="#1c2343"
          fill-opacity="1"
          id="Icon_awesome-arrow-down"
          data-name="Icon awesome-arrow-down"
          class="cls-2 animate-bounce"
          d="M189.36,76.48,191.87,79a2.71,2.71,0,0,1,0,3.83l0,0-22,22a2.71,2.71,0,0,1-3.83,0l0,0-22-22A2.7,2.7,0,0,1,144,79l0,0,2.52-2.52a2.72,2.72,0,0,1,3.84,0l0,0,13,13.63V57.64a2.71,2.71,0,0,1,2.7-2.71h3.64a2.71,2.71,0,0,1,2.71,2.7h0V90.15l13-13.63a2.69,2.69,0,0,1,3.82-.11l.06.06Z"
        />
      </svg>
    </a>
  </div>
</template>

<script>
import {
  createUserWithEmailAndPassword,
  getAuth,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  fetchSignInMethodsForEmail,
  updatePassword,
} from "firebase/auth";
import {
  collection,
  doc,
  getDoc,
  onSnapshot,
  query,
  setDoc,
  where,
  getDocs,
  deleteDoc,
} from "firebase/firestore";

import { db } from "@/firebase/db";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  name: "Header",

  componenets: {},
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  data: () => ({
    showMenu: false,
    showSlideOver: false,
    isFirstTimeUser: true,
    isLoggedIn: false,
    isLoad: false,
    showMobileMenu: false,
    authUnsubscribe: null,
    userSnapshotUnsubscribe: null,
    errorMessage: "",
    emailCheckDebounceTimer: null,
    emailExistsInFirestore: null,
    isCheckingEmail: false,
    showPassword: false,
    showConfirmPassword: false,
    passwordMatchDebounceTimer: null,
    passwordMatchError: false,
    loginInformation: {
      email: "",
      password: "",
    },
    registrationInformation: {
      fullName: "",
      icNo: "",
      address: "",
      password: "",
      confirmPassword: "",
      gender: "",
      phoneNumber: "",
      email: "",
    },
    bankInformation: {
      accountHolderName: "",
      accountNo: "",
      bankName: "",
    },
    user: {},
  }),

  validations() {
    return {
      registrationInformation: {
        fullName: { required },
        icNo: { required },
        address: { required },
        password: { required },
        confirmPassword: { required },
        gender: { required },
        phoneNumber: { required },
        email: { required },
      },
      bankInformation: {
        accountHolderName: { required },
        accountNo: { required },
        bankName: { required },
      },
    };
  },

  computed: {
    bgImage() {
      return require("@/assets/images/header-banner.png");
    },
    logoWhite() {
      return require("@/assets/images/logo-white.png");
    },
    logoImage() {
      return {
        background: `url(${this.logoWhite})`,
        backgroundSize: "cover !important",
        display: "block",
      };
    },
    image() {
      return {
        background: `url(${this.bgImage})`,
        backgroundSize: "cover !important",
        display: "block",
      };
    },
  },
  watch: {
    "loginInformation.email"(newEmail) {
      this.debouncedEmailCheck(newEmail);
    },
  },
  created() {
    this.checkUserState();
  },
  beforeUnmount() {
    // Cleanup Firebase Auth listener
    if (this.authUnsubscribe) {
      this.authUnsubscribe();
      this.authUnsubscribe = null;
    }

    // Cleanup Firestore snapshot listener
    if (this.userSnapshotUnsubscribe) {
      this.userSnapshotUnsubscribe();
      this.userSnapshotUnsubscribe = null;
    }

    // Clear email check debounce timer
    if (this.emailCheckDebounceTimer) {
      clearTimeout(this.emailCheckDebounceTimer);
      this.emailCheckDebounceTimer = null;
    }

    // Clear password match debounce timer
    if (this.passwordMatchDebounceTimer) {
      clearTimeout(this.passwordMatchDebounceTimer);
      this.passwordMatchDebounceTimer = null;
    }
  },
  methods: {
    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    async checkUserExistsInFirestore(email) {
      // this function should check the email in firebase auth if its exist or not
      try {
        const auth = getAuth();
        const user = await fetchSignInMethodsForEmail(auth, email);
      if (user.length > 0) {
        return true;
      }
      return false;
        // const userDocsRef = await getDocs(
        //   query(collection(db, "users"), where("email", "==", email))
        // );
        // // Use userDocsRef.docs[0].id to recheck again in the heir collection where user id == 
        // const heirDocsRef = await getDocs(
        //   query(collection(db, "heirs"), where("user_id", "==", userDocsRef.docs[0].id))
        // );
        // if (heirDocsRef.empty) {
        //   return false;
        // }
        // return true;
      } catch (error) {
        console.error("Error checking user in Firestore:", error);
        return false;
      }
    },
    debouncedEmailCheck(email) {
      // Clear existing timer
      if (this.emailCheckDebounceTimer) {
        clearTimeout(this.emailCheckDebounceTimer);
      }

      // Reset state if email is invalid
      if (!email || !this.isValidEmail(email)) {
        this.emailExistsInFirestore = null;
        return;
      }

      // Set checking state
      this.isCheckingEmail = true;

      // Create new debounced timer (500ms)
      this.emailCheckDebounceTimer = setTimeout(async () => {
        try {
          const exists = await this.checkUserExistsInFirestore(email);
          this.emailExistsInFirestore = exists;
        } catch (error) {
          console.error("Email check error:", error);
          this.emailExistsInFirestore = null;
        } finally {
          this.isCheckingEmail = false;
        }
      }, 500);
    },
    clearEmailCheckState() {
      if (this.emailCheckDebounceTimer) {
        clearTimeout(this.emailCheckDebounceTimer);
        this.emailCheckDebounceTimer = null;
      }
      this.emailExistsInFirestore = null;
      this.isCheckingEmail = false;
    },
    debouncedPasswordMatchCheck() {
      if (this.passwordMatchDebounceTimer) {
        clearTimeout(this.passwordMatchDebounceTimer);
      }
      
      this.passwordMatchDebounceTimer = setTimeout(() => {
        if (this.registrationInformation.confirmPassword.length > 0) {
          this.passwordMatchError = 
            this.registrationInformation.password !== this.registrationInformation.confirmPassword;
        } else {
          this.passwordMatchError = false;
        }
      }, 500);
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmPasswordVisibility() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    closeSlideOver() {
      this.showSlideOver = false;
      this.clearEmailCheckState();
    },
    mobileSignIn() {
      this.showMobileMenu = !this.showMobileMenu;
      this.showSlideOverOrRedirect();
    },
    async signIn() {
      // Clear any previous error messages
      this.errorMessage = "";

      // Validate input
      if (
        !this.loginInformation.password ||
        !this.loginInformation.email
      ) {
        this.errorMessage = "Sila isi emel dan kata laluan";
        return;
      }

      const auth = getAuth();
      this.isLoad = true;

      try {
        // Handle temporary password for first-time users
        if (this.loginInformation.password === "password") {
          // Use pre-checked value if available, otherwise check now
          const userExists =
            this.emailExistsInFirestore !== null
              ? this.emailExistsInFirestore
              : await this.checkUserExistsInFirestore(
                  this.loginInformation.email
                );
          if (userExists) {
            // User already registered, reject temporary password
            this.errorMessage =
              "Kata laluan sementara tidak lagi sah. Sila gunakan kata laluan yang didaftarkan.";
            this.isLoad = false;
            return;
          }

          // First-time user - create Firebase Auth account with temporary password
          await createUserWithEmailAndPassword(
            auth,
            this.loginInformation.email,
            this.loginInformation.password
          );

          // Check if admin already created user profile
          const userDocsRef = await getDocs(
            query(collection(db, "users"), where("email", "==", this.loginInformation.email))
          );

          if (!userDocsRef.empty) {
            // Pre-populate form with admin-created data
            const adminUserData = userDocsRef.docs[0].data();
            this.registrationInformation = {
              fullName: adminUserData.full_name || "",
              icNo: adminUserData.ic_no || "",
              address: adminUserData.address || "",
              password: "",
              confirmPassword: "",
              gender: adminUserData.gender || "",
              phoneNumber: adminUserData.phone_number || "",
              email: this.loginInformation.email,
            };
            this.bankInformation = {
              accountHolderName: adminUserData.account_holder_name || "",
              accountNo: adminUserData.bank_account || "",
              bankName: adminUserData.bank_name || "",
            };
          } else {
            // Set registration email same as login email
            this.registrationInformation.email = this.loginInformation.email;
          }

          // Set as first-time user and show registration form
          this.isLoggedIn = true;
          this.isFirstTimeUser = true;
          this.isLoad = false;
          // Registration form will be shown automatically via v-if condition
        } else {
          // Normal login with actual password
          const signInUser = await signInWithEmailAndPassword(
            auth,
            this.loginInformation.email,
            this.loginInformation.password
          );

          // Check Firestore to determine if user is first-time
          const userDocRef = doc(db, "users", signInUser.user.uid);
          const userDocSnap = await getDoc(userDocRef);

          if (userDocSnap.exists()) {
            // User exists in Firestore - not first-time user
            this.isLoggedIn = true;
            this.isFirstTimeUser = false;
            this.user = userDocSnap.data();
            this.isLoad = false;
            this.clearEmailCheckState();
            this.$router.push("/user-profile");
          } else {
            // User authenticated but doesn't exist in Firestore - first-time user
            this.isLoggedIn = true;
            this.isFirstTimeUser = true;
            this.isLoad = false;
            // Registration form will be shown automatically via v-if condition
          }
        }
      } catch (error) {
        // Handle Firebase Auth errors
        this.isLoad = false;
        this.isLoggedIn = false;

        let errorMsg = "Ralat berlaku semasa log masuk. Sila cuba lagi.";
        
        if (error.code === "auth/user-not-found") {
          errorMsg = "Emel tidak ditemui. Sila pastikan emel anda betul.";
        } else if (error.code === "auth/wrong-password") {
          errorMsg = "Kata laluan tidak betul. Sila cuba lagi.";
        } else if (error.code === "auth/invalid-email") {
          errorMsg = "Format emel tidak sah.";
        } else if (error.code === "auth/user-disabled") {
          errorMsg = "Akaun ini telah dinyahaktifkan.";
        } else if (error.code === "auth/email-already-in-use") {
          errorMsg = "Emel ini sudah digunakan. Sila gunakan kata laluan yang didaftarkan.";
        } else if (error.code) {
          console.error("Firebase Auth Error:", error.code, error.message);
        }

        this.errorMessage = errorMsg;
      }
    },
    async signUp() {
      const isFormCorrect = await this.v$.$validate();
      if (!isFormCorrect) return;
      
      // Check password match one final time
      if (this.registrationInformation.password !== this.registrationInformation.confirmPassword) {
        window.alert("Kata laluan tidak sepadan");
        return;
      }
      
      this.showSlideOver = !this.showSlideOver;
      
      const auth = getAuth();
      const currentUser = auth.currentUser;
      
      // Update password from temporary to actual
      await updatePassword(currentUser, this.registrationInformation.password);
      
      const userId = currentUser.uid;
      const userPayload = {
        full_name: this.registrationInformation.fullName,
        address: this.registrationInformation.address,
        ic_no: this.registrationInformation.icNo,
        phone_number: this.registrationInformation.phoneNumber,
        gender: this.registrationInformation.gender,
        email: this.registrationInformation.email,
        bank_account: this.bankInformation.accountNo,
        bank_name: this.bankInformation.bankName,
        account_holder_name: this.bankInformation.accountHolderName,
        id: userId,
        status: true,
        created_at: new Date(),
        updated_at: new Date(),
      };
      
      // Check if admin already created user with share_id/heir_id
      const userDocsRef = await getDocs(
        query(collection(db, "users"), where("email", "==", userPayload.email))
      );
      
      if (!userDocsRef.empty) {
        const userDataCreatedByAdmin = userDocsRef.docs[0].data();
        if (userDataCreatedByAdmin.share_id) {
          userPayload.share_id = userDataCreatedByAdmin.share_id;
        }
        if (userDataCreatedByAdmin.heir_id) {
          userPayload.heir_id = userDataCreatedByAdmin.heir_id;
        }
        // Delete old document
        await deleteDoc(doc(db, "users", userDataCreatedByAdmin.id));
      }
      
      // Save final user document
      await setDoc(doc(db, "users", userId), userPayload);
      
      this.isFirstTimeUser = false;
      this.$router.push("/user-profile");
    },
    register() {
      // TODO: Run some function here
      this.isLoggedIn = true;
      this.isFirstTImeUser = false;
      this.showSlideOver = !this.showSlideOver;
      if (!this.isFirstTImeUser) {
        this.$router.push("/user-profile");
      }
    },

    checkUserState() {
      const auth = getAuth();

      // Store unsubscribe function to cleanup later
      this.authUnsubscribe = onAuthStateChanged(auth, async (user) => {
        if (user) {
          this.isLoggedIn = true;
          
          // Store unsubscribe function for Firestore snapshot
          this.userSnapshotUnsubscribe = onSnapshot(
            doc(db, "users", user.uid),
            async (userDocSnap) => {
              if (userDocSnap.exists()) {
                this.user = userDocSnap.data();
                // User exists in Firestore - not first-time user
                this.isFirstTimeUser = false;

                if (this.user.share_id) {
                  const shareInformationDocSnap = await getDoc(
                    doc(db, "shares", this.user.share_id)
                  );
                  if (shareInformationDocSnap.exists()) {
                    this.share = shareInformationDocSnap.data();
                  }
                }
              } else {
                // User authenticated but doesn't exist in Firestore - first-time user
                this.isFirstTimeUser = true;
              }
            }
          );
        } else {
          // User not authenticated
          this.isLoggedIn = false;
          this.isFirstTimeUser = true;
          this.user = {};
          
          // Cleanup Firestore snapshot if it exists
          if (this.userSnapshotUnsubscribe) {
            this.userSnapshotUnsubscribe();
            this.userSnapshotUnsubscribe = null;
          }
        }
      });
    },

    showSlideOverOrRedirect() {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      
      if (currentUser) {
        // User is already authenticated, redirect to profile
        this.$router.push("/user-profile");
      } else {
        // User not authenticated, show login slide-over
        this.showSlideOver = !this.showSlideOver;
      }
    },
  },
};
</script>

<style>
.bg-green-fluorescent {
  background-color: #94de2a;
}
.shadow {
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.16);
}
.rectangle-23 {
  width: 18px;
  height: 18px;
  margin: 31px 19px 288px 4px;
  /* background-color: #94de2a; */
}
</style>
